import { fieldsMixin } from './fields.mixin';

if (document.getElementById('contactForm')) {


    var app = new Vue({
        el: '#contactForm',
        mixins: [fieldsMixin],
        data() {
            return {
                subject: '',
                local_fields: {},
                form_selection: [],
                forms: [],
                active_form: ''

            }
        },

        mounted() {
            this.forms = JSON.parse(document.getElementById('formFields').innerHTML).ticket_forms;
            this.active_form = this.forms[0].id
        },

        methods: {
            hasError() {
                return false;
            },

            submit() {
                console.log(this.activeForm.form_index)
                this.submitForm({}, this.active_form)
            }
        },

        computed: {
            activeForm() {

                let formName = '';
                let formIndex = 0;

                if (this.forms) {
                    this.forms.forEach((form, index) => {
                        if (form.id == this.active_form) {
                            formName = form.name;
                            formIndex = index
                        }
                    });
                }
                return {
                    form_name: formName,
                    form_index: formIndex
                };


            },
        }
    })
};